export * from "@/ui/components/primitives/Badge/Badge";
export * from "@/ui/components/primitives/Badge/Badge.config";
